import React from 'react';
import { Link } from "react-router-dom";
import Header from "../components/Header";
import HeroSection from "../components/HeroSection";
import ServiceHighlights from "../components/ServiceHighlights";
import ServicesOverview from "../components/ServicesOverview";
import Footer from "../components/Footer";
import PartnerMarquee from "../components/PartnerMarquee";
import HelpButton from "../components/HelpButton";
import ActivationSteps from "../components/ActivationSteps";
import { Phone } from "lucide-react";
import RenovatieFAQ from "../components/faqs/RenovatieFAQ";
import { Reviews } from '../components/Reviews';
import SEO from '../components/SEO';

function StopcontactenPlaatsen() {
  return (
    <div className="min-h-screen bg-white page-transition pt-[99px] md:pt-[133px]">
      <SEO
        title="Stopcontacten laten plaatsen - elektricieninarnhem026.nl"
        description="Professionele installatie van extra stopcontacten in uw woning. Onze experts zorgen voor een veilige en nette afwerking."
        image="/images/banner.png"
      />
      <Header />
      <HeroSection
        title="Stopcontacten laten plaatsen"
        description="Professionele installatie van extra stopcontacten in uw woning. Onze experts zorgen voor een veilige en nette afwerking."
        imageSrc="/images/mark.png"
      />


      {/* Features Section */}
      <section className="mx-auto w-[calc(100%-2.5rem)] max-w-[1088px] mb-12 md:mb-16">
        <div className="grid items-center w-full gap-12 grid-cols-1 md:grid-cols-2 mb-16 md:mb-20 xl:mb-20">
          <div className="[&_p]:!text-[#17354A] [&_p]:text-base md:[&_p]:text-lg order-2 md:order-none">
            <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-4 md:mb-6">
              Waarom extra stopcontacten laten plaatsen?
            </h2>
            <p>
              Heeft u te weinig stopcontacten in uw woning? Met de toename van elektrische apparaten
              en gadgets is het hebben van voldoende stopcontacten essentieel geworden. Steeds meer
              mensen kiezen ervoor om extra stopcontacten te laten plaatsen voor meer gemak en
              veiligheid. Wij zorgen voor een professionele installatie van nieuwe stopcontacten,
              perfect geïntegreerd in uw bestaande elektrische systeem.
            </p>

            <div className="h-9"></div>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/offerte"   aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"

                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-transparent items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] bg-[#F47B20] text-white hover:bg-[#F47B20]/80 focus:bg-[#F47B20]/80 focus-visible:border-crustaLight disabled:bg-[#F47B20]/40 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  Offerte aanvragen
                </span>
              </Link>

              <a
                href="tel:+31852129778"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-[#17354A] items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] text-[#17354A] hover:bg-[#E6B800] hover:text-white focus:opacity-60 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  <Phone className="w-4 h-4" />
                  Bel direct 085-2129778
                </span>
              </a>
            </div>
          </div>
          <div className="order-1 md:-order-1">
            <div className="relative">
              <span className="absolute bg-[#E6B800] text-white px-2 py-1 text-xs  rounded-md opacity-20 top-1/4 right-1/3">
                elektricieninarnhem026.nl
              </span>

              <img
                alt="Stopcontacten"
                loading="lazy"
                className="rounded-lg w-full h-auto"
                src="/images/stopcontacten.png"
              />
            </div>
          </div>
        </div>

        <ActivationSteps />

        <div className="grid items-center w-full gap-12 grid-cols-1 md:grid-cols-2 mb-16 md:mb-20 xl:mb-20">
          <div className="[&_p]:!text-[#17354A] [&_p]:text-base md:[&_p]:text-lg order-2 md:order-1">
            <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-4 md:mb-6">
              Professionele installatie van stopcontacten
            </h2>
            <p>
              Het plaatsen van extra stopcontacten vereist vakkundig werk. Onze ervaren elektriciens
              zorgen voor een veilige installatie volgens de laatste NEN-normen. We kunnen stopcontacten
              toevoegen in elke ruimte van uw woning, of het nu gaat om de woonkamer, keuken, slaapkamer
              of studeerkamer. We zorgen voor een nette afwerking en minimale overlast tijdens de
              werkzaamheden.
            </p>

            <div className="h-9"></div>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/offerte"   aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"

                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-transparent items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] bg-[#F47B20] text-white hover:bg-[#F47B20]/80 focus:bg-[#F47B20]/80 focus-visible:border-crustaLight disabled:bg-[#F47B20]/40 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  Offerte aanvragen
                </span>
              </Link>

              <a
                href="tel:+31852129778"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-[#17354A] items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] text-[#17354A] hover:bg-[#E6B800] hover:text-white focus:opacity-60 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  <Phone className="w-4 h-4" />
                  Bel direct 085-2129778
                </span>
              </a>
            </div>
          </div>
          <div className="order-1 md:order-2">
            <div className="relative">
              <span className="absolute bg-[#E6B800] text-white px-2 py-1 text-xs  rounded-md opacity-20 top-1/4 right-1/3">
                elektricieninarnhem026.nl
              </span>

              <img
                alt="Installatie"
                loading="lazy"
                className="rounded-lg w-full h-auto"
                src="/images/installatie.png"
              />
            </div>
          </div>
        </div>

        <div className="grid items-center w-full gap-12 grid-cols-1 md:grid-cols-2 mb-16 md:mb-20 xl:mb-20">
          <div className="[&_p]:!text-[#17354A] [&_p]:text-base md:[&_p]:text-lg order-2 md:order-none">
            <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-4 md:mb-6">
              Waar let je op bij nieuwe stopcontacten?
            </h2>
            <p>
              Bij het plaatsen van nieuwe stopcontacten is het belangrijk om rekening te houden met
              de capaciteit van uw groepen. We controleren of extra stopcontacten op bestaande groepen
              kunnen worden aangesloten of dat er een nieuwe groep nodig is. Ook kijken we naar de
              meest praktische locaties en kunnen we adviseren over speciale opties zoals USB-stopcontacten
              of kindveilige wandcontactdozen.
            </p>

            <div className="h-9"></div>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/offerte"   aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"

                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-transparent items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] bg-[#F47B20] text-white hover:bg-[#F47B20]/80 focus:bg-[#F47B20]/80 focus-visible:border-crustaLight disabled:bg-[#F47B20]/40 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  Offerte aanvragen
                </span>
              </Link>

              <a
                href="tel:+31852129778"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-[#17354A] items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] text-[#17354A] hover:bg-[#E6B800] hover:text-white focus:opacity-60 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  <Phone className="w-4 h-4" />
                  Bel direct 085-2129778
                </span>
              </a>
            </div>
          </div>
          <div className="order-1 md:-order-1">
            <div className="relative">
              <span className="absolute bg-[#E6B800] text-white px-2 py-1 text-xs  rounded-md opacity-20 top-1/4 right-1/3">
                elektricieninarnhem026.nl
              </span>
              <img
                alt="Stopcontact Details"
                loading="lazy"
                className="rounded-lg w-full h-auto"
                src="/images/stopcontact-details.png"
              />
            </div>
          </div>
        </div>
      </section>

      <ServicesOverview />
      <RenovatieFAQ />


      <ServiceHighlights />

      <Reviews />

      <PartnerMarquee />

      {/* CTA Section */}
      <div className="w-full cursor-pointer bg-[#FFD100] transition-opacity duration-150 hover:opacity-80">
        <Link to="/offerte"   aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
>
          <section className="mx-auto w-[calc(100%-2.5rem)] max-w-[1088px] text-center py-6 justify-between items-center">
            <div
              data-variant="h2"
              className="font-bold leading-[1.25] text-[28px] lg:text-[36px] self-center text-white mb-0"
            >
              Offerte aanvragen
            </div>
          </section>
        </Link>
      </div>

      <HelpButton />
      <Footer />
    </div>
  );
}

export default StopcontactenPlaatsen;